import React from 'react';
import { CheckCircleIcon } from 'icons';

import { Modal } from 'components';

interface IProps {
  onClose: () => void;
  open: boolean;
  title?: string;
  desc?: string;
}

const SuccessModal: React.FC<IProps> = ({ onClose, open, title, desc }) => (
  <Modal
    footer={false}
    open={open}
    centered
    onClose={onClose}
    width="360px"
    closeIcon={false}
    styles={{
      content: { padding: '16px', borderRadius: '12px' }
    }}
  >
    <div className="flex flex-col items-center justify-center py-4">
      <CheckCircleIcon size="100" />
      <p className="mt-4 text-xl font-medium">{title}</p>
      <p className="text-sm text-gray-600 text-center">{desc}</p>
    </div>
  </Modal>
);

export default SuccessModal;
